module.exports = __webpack_public_path__ + "static/media/app-store-sv.248a52c5.svg";